import React from 'react'
import styles from './Shopify.module.scss'

export const WhyIntegrate = () => (
    <div className={`module ${styles.WhyIntegrate}`}>
        <div className="module-header">
            <h2>Why Integrate?</h2>
        </div>
        <p>Integrating Shopify with Betterspace means that you will benefit from the following features:</p>
        <ul>
            <li>Betterspace Orders will appear directly on your Shopify Orders; no more exporting and importing CSVs.</li>
            <li>Stock levels will be automatically pulled from Shopify; no need to manage your stock in two places.</li>
            <li>Coming soon: Betterspace users will see more accurate updates for their orders (e.g. Dispatched, Delivered).</li>
        </ul>
    </div>
)
